export const ALPHA_GUILDS_SWR_KEY = "alpha-guilds"
export const ALPHA_GUILDS_API_URL =
  "https://api-alpha.guild.xyz/guilds?isVerified=true"
